import React from 'react';
import './ContentLoader.scss';

interface ContentLoaderProps {
  text?: string;
  size?: 'small' | 'medium' | 'large';
  variant?: 'default' | 'minimal' | 'card';
}

const ContentLoader: React.FC<ContentLoaderProps> = ({ 
  text = 'Loading...', 
  size = 'medium',
  variant = 'default'
}) => {
  return (
    <div className={`content-loader ${size} ${variant}`}>
      <div className="content-loader-overlay" />
      
      <div className="content-loader-content">
        {/* Spinner */}
        <div className="content-spinner">
          <div className="content-spinner-circle"></div>
        </div>
        
        {/* Loading text */}
        {text && variant !== 'minimal' && (
          <div className="content-loader-text">
            <span>{text}</span>
            <div className="content-dots">
              <span className="content-dot"></span>
              <span className="content-dot"></span>
              <span className="content-dot"></span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ContentLoader;